import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import { EXTERNAL_LOGIN_URL } from "../../../../consts";
import { getLoggedIn } from "../../../../store/selectors";
import { getIsIpDomain } from "../../../../utils";

const RedirectHome = () => {
  const loggedIn = useSelector(getLoggedIn);

  const isIpDomain = getIsIpDomain();

  useEffect(() => {
    if (!loggedIn && !isIpDomain) {
      window.location.replace(EXTERNAL_LOGIN_URL);
    }
  }, [loggedIn]);

  if (loggedIn) {
    return <Navigate to="/home" replace />;
  }

  return null;
};

export default RedirectHome;
